/**
 * Label for the user who created a job order; admins are marked as such.
 * Orders created before `createdBy` was tracked don't have it; those were always
 * created by their owner, so the owner is shown.
 * @param {{ createdBy?: object | null, user?: object | null } | null | undefined} jobOrder
 * @returns {string}
 */
export function formatCreatedBy(jobOrder) {
  const user = jobOrder?.createdBy || jobOrder?.user;
  if (!user) return '—';
  const name = user.name || user.email || `#${user.id}`;
  if (user.role !== 'ADMIN' || name.toLowerCase() === 'admin') return name;
  return `${name} (Admin)`;
}
